module.exports = __webpack_public_path__ + "e2634e96c9ad4694d5133cc83e2c6564.svg";